<app-autocomplete
  [control]="control"
  [itemsSource]="items"
  [helpText]="'Inneh&aring;ller lediga objekt. Objekt som inte har ett aktivt hyreskontrakt &auml;r lediga.'"
></app-autocomplete>
